/**
 * Endpoint 1 — GET calculator/app (research/07 §1). Two call shapes exist in
 * v1 (product vs non-product page); both concatenate raw values, never
 * URL-encoded (REQ-API-2), and return the raw fetch Response so the callers
 * keep their own 204/json handling (REQ-API-5).
 */
import { appState } from "../state/app-state";
import { shopperLocale } from "../i18n/translate";
import { fetchRetryingOnce } from "./fetch-retry";
import { resolvedConfigResponse } from "./calculator-resolve";

/**
 * Translations v1: the shopper's `window.Shopify.locale`, appended ONLY when
 * the theme global carries one, so every request made today is unchanged.
 * Unencoded like every other value here (REQ-API-2); locale codes are plain.
 */
function localeParam(): string {
  const locale = shopperLocale();
  return locale ? "&locale=" + locale : "";
}

/** Product-page shape (process_product_page.js LoadCalculator — 5 params). */
export async function LoadCalculator(calculatorId: any, isPreview: any): Promise<Response> {
  // DIV-027: already fetched by the resolve call — hand it back as the Response
  // this function always returned, no request.
  const resolved = await resolvedConfigResponse(String(calculatorId));
  if (resolved) return resolved;
  var sourceUrl = window.location.href.split("?")[0];
  var url =
    appState.baseCalculatorNewApiUrl +
    "calculator/app?calculatorId=" +
    calculatorId +
    "&productId=" +
    appState.cpc_productId +
    "&isPreview=" +
    isPreview +
    "&shop=" +
    appState.cpc_shopUrl +
    "&productUrl=" +
    sourceUrl +
    localeParam();
  // DIV-022: one retry when the request itself never completed — see fetch-retry.ts.
  return await fetchRetryingOnce(url);
}

/** Non-product shape (process_nonproduct_page.js LoadCalculator — 3 params). */
export async function LoadCalculatorNonProduct(
  calculatorId: any,
  isPreview: any,
): Promise<Response> {
  // DIV-027: see LoadCalculator.
  const resolved = await resolvedConfigResponse(String(calculatorId));
  if (resolved) return resolved;
  var url =
    appState.baseCalculatorNewApiUrl +
    "calculator/app?calculatorId=" +
    calculatorId +
    "&isPreview=" +
    isPreview +
    "&shop=" +
    appState.cpc_shopUrl +
    localeParam();
  // DIV-022: one retry when the request itself never completed — see fetch-retry.ts.
  return await fetchRetryingOnce(url);
}
